<template>
  <div v-if="feedTabList.length" class="index-feed-tab" :style="bgStyle">
    <scroll-view class="feed-tab-scroll" scroll-x display="absolute">
      <!-- 单个tab -->
      <div
        v-for="(tab, index) in feedTabList"
        :id="`index-feed-tab-${index}`"
        :key="tab.data_id"
        class="feed-tab-item"
        @click="bindClickTab(index)"
      >
        <!-- tab标题 -->
        <span
          class="tab-title"
          :style="{
            color:
              index === currentIndex
                ? style.selectedTitleColor
                : style.unselectTitleColor,
            fontWeight: index === currentIndex ? 500 : 'normal'
          }"
        >
          {{ `${tab.title}`.slice(0, 8) }}
        </span>
        <!-- tab子标题 -->
        <span
          v-if="tab.subTitle"
          class="tab-sub-title"
          :style="{
            color:
              index === currentIndex
                ? style.selectedSubTitleColor
                : style.unselectSubTitleColor,
            backgroundColor:
              index === currentIndex ? style.subTitleBgColor : 'transparent'
          }"
        >
          {{ tab.subTitle }}
        </span>
        <!-- 选中tab时底下的border -->
        <span
          v-if="index === currentIndex && !tab.subTitle"
          class="bottom-border"
          :style="{ backgroundColor: style.selectedTitleColor }"
        ></span>
      </div>
    </scroll-view>
  </div>
</template>

<script>
import ScrollView from '@/common/widget/ScrollView/index.vue'
import { miniProgramEnv } from '@/defines/environment'

export default {
  components: {
    ScrollView
  },
  props: {
    feedTabData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentIndex: 0 // 当前选中的tab Index
    }
  },
  computed: {
    // feed流tab列表
    feedTabList() {
      return (this.feedTabData && this.feedTabData.data) || []
    },
    // tab栏样式（服务端获取）
    style() {
      return (this.feedTabData && this.feedTabData.style) || {}
    },
    // tab栏背景样式（服务端获取）
    bgStyle() {
      const imgUrl = (this.style.bgImg && this.style.bgImg.img_url) || ''
      return imgUrl
        ? {
            backgroundImage: `url('${imgUrl}')`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            top: this.stickyTop
          }
        : {
            backgroundColor: '#fff',
            top: this.stickyTop
          }
    },
    stickyTop() {
      if (miniProgramEnv.isMiniProgram) return '0px'
      return this.statusBarHeight + 44 + 'px'
    }
  },
  methods: {
    // 点击feed Tab
    bindClickTab(index) {
      this.currentIndex = index
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('onTabChange', {
        index
      })
      const tabDom = document.querySelector(`#index-feed-tab-${index}`)
      tabDom.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.feed-tab-scroll {
  writing-mode: initial !important;
  @include flex(row, flex-start, flex-start, nowrap);

  .feed-tab-item {
    box-sizing: border-box;

    position: relative;

    width: 1.7rem;
    height: 1rem;
    padding: 0 0.26rem 0 0.24rem;

    flex: none;
    @include flex(column, center, center, nowrap);

    // 右 border
    &:after {
      display: block;

      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);

      width: 0.02rem;
      height: 0.4rem;

      background-color: rgba(0, 0, 0, 0.1);

      content: '';
    }
    &:last-child {
      &:after {
        display: none;
      }
    }

    .tab-title {
      flex: none;

      font-size: 0.28rem;
      text-align: center;

      color: #333;
    }
    .tab-sub-title {
      width: 1.32rem;
      height: 0.36rem;
      overflow: hidden;

      border-radius: 0.18rem;

      flex: none;

      font-size: 0.22rem;
      line-height: 0.36rem;
      text-align: center;

      color: #fff;
    }
    .bottom-border {
      position: absolute;
      bottom: 0.04rem;
      left: 50%;
      transform: translateX(-50%);

      width: 0.4rem;
      height: 0.04rem;
    }
  }
}
.index-feed-tab {
  position: -webkit-sticky;
  position: sticky;
  // top: 0;
  z-index: 99;

  width: 100%;
  max-width: 668px;
  height: 1rem;
}
</style>
